import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.updateRegistryPhyto.success: {
            return action.payload;
        }

        case constants.updateRegistryPhyto.error: {
            return initialState;
        }

        case constants.updateRegistryPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}